import React, { ChangeEvent } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import CollapsibleContentContainer from '../../../../../../common/components/CollapsibleContentContainer/CollapsibleContentContainer';
import OptinPageBuilder from '../../../../../../common/components/OptinPageBuilder/OptinPageBuilder';
import PageSelector from '../PageSelector';
import { MessengerAdModel } from '@mm/state/model/MessengerAdModel';
import MessengerAdCRUDActions from '@mm/state/actions/MessengerAdCRUDActions';
import './ContentBuilder.scss';

type OuterProps = {
  ad: MessengerAdModel;
  activeChatbotId: number;
};

type PropsFromDispatch = ReturnType<typeof mapDispatchToProps>;

type InnerProps = PropsFromDispatch;

type Props = InnerProps & OuterProps;

const ContentSelector = ({
  ad,
  activeChatbotId,
  updateAd,
  retrieveAd,
}: Props) => (
  <CollapsibleContentContainer
    orderNumber="3"
    containerName="Choose content to send to your users"
  >
    <div className="ad-details__section-container">
      <div className="ad-content-builder">
        <div className="ad-content-builder__radio-text ad-content-builder__optin-message">
          <input
            type="radio"
            checked={ad.optinPageEnabled}
            value="optinPage"
            onChange={updateAd}
          />{' '}
          Create an opt-in message
        </div>
        <div>
          <div className="ad-content-builder__radio-text">
            <input
              type="radio"
              value="page"
              checked={!ad.optinPageEnabled}
              onChange={updateAd}
            />{' '}
            Choose a Dialogue (not recommended)
          </div>
          <div className="ad-content-builder__help">
            Warning: Attributes and many widget types are not supported by
            Facebook in this context.&nbsp;
            <a
              href="https://mobilemonkey.com/help/article/gtwfu1tsmn"
              target="_blank"
              rel="noopener noreferrer"
            >
              See our help doc
            </a>{' '}
            for more information.
          </div>
        </div>
      </div>
      {ad.optinPageEnabled ? (
        <div className="ad-content-builder__optin-page-container">
          <OptinPageBuilder
            optinPage={ad.optinPageAttributes}
            onRemoteWidgetUpdated={retrieveAd}
          />
        </div>
      ) : (
        <PageSelector chatbotId={activeChatbotId} ad={ad} />
      )}
    </div>
  </CollapsibleContentContainer>
);

const mapDispatchToProps = (dispatch, { ad, activeChatbotId }: OuterProps) => ({
  updateAd: (e: ChangeEvent<HTMLInputElement>) => {
    const optinPageEnabled = e.target.value === 'optinPage' ? true : false;
    const updatedAd = Object.assign({}, ad, { optinPageEnabled });
    dispatch(MessengerAdCRUDActions.updateLegacy(activeChatbotId, updatedAd));
  },
  retrieveAd: () => {
    return dispatch(
      MessengerAdCRUDActions.retrieveById(activeChatbotId, ad.id),
    );
  },
});

const enhance = compose<InnerProps, OuterProps>(
  connect(null, mapDispatchToProps),
);

export default enhance(ContentSelector);
